import { URL } from '@core/constants/url.constant';
import { ApiValidate } from '@core/decorators/ApiValidate.decorator';
import { tokenSchema } from '@core/schemas/tokenService.schema';
import { apiService } from '@core/services/Api.service';
import { tokenVerificationResponseSchema } from '../schemas/resetPassword.schema';
import type {
  TResetPasswordDTO,
  TResetPasswordResponse,
  TTokenVerificationResponse,
  TTokenVerificationDTO
} from '../models/resetPassword.model';

class ResetPasswordService {
  @ApiValidate(tokenSchema)
  public reset(dto: TResetPasswordDTO) {
    return apiService.put<TResetPasswordResponse>({
      url: URL.resetPassword,
      dto
    });
  }

  @ApiValidate(tokenVerificationResponseSchema)
  public verifyToken(dto: TTokenVerificationDTO) {
    return apiService.post<TTokenVerificationResponse>({
      url: URL.tokenVerification,
      dto
    });
  }
}

const resetPasswordService = new ResetPasswordService();

export { resetPasswordService };
